import { render, staticRenderFns } from "./canvas.vue?vue&type=template&id=6a41ad5c&"
import script from "./canvas.vue?vue&type=script&lang=js&"
export * from "./canvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmtkpv/Projects/barcode-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6a41ad5c', component.options)
    } else {
      api.reload('6a41ad5c', component.options)
    }
    module.hot.accept("./canvas.vue?vue&type=template&id=6a41ad5c&", function () {
      api.rerender('6a41ad5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/routes/template/asides/canvas.vue"
export default component.exports